import { z } from "zod";

export const resetPasswordPayloadSchema = z.object({
  authKey: z.string().nonempty("인증키를 입력해 주세요."),
  account: z.string().nonempty("회원 아이디를 입력해 주세요."),
  password: z
    .string()
    .min(8, "비밀번호는 최소 8자 이상이어야 합니다.")
    .max(12, "비밀번호는 최대 12자 이하이어야 합니다.")
    .refine((value) => !/\s/.test(value), "공백은 사용할 수 없습니다.")
    .refine((value) => !/[ㄱ-ㅎㅏ-ㅣ가-힣]/.test(value), "한글은 사용할 수 없습니다.")
    .refine((value) => {
      const hasLetter = /[a-zA-Z]/.test(value);
      const hasNumber = /[0-9]/.test(value);
      const hasSpecial = /[!@#$%^&*(),.?":{}|<>_\-\\[\]\/~`+=;'']/g.test(value);
      const types = [hasLetter, hasNumber, hasSpecial].filter(Boolean);
      return types.length >= 2;
    }, "영문, 숫자, 특수문자 중 2가지 이상 조합해야 합니다."),
});

export type ResetPasswordPayloadType = z.infer<typeof resetPasswordPayloadSchema>;
